export enum LifeCycleIndex {
  ngOnChange = 0,
  ngOnInit = 1,
  ngDoCheck = 2,
  ngAfterContentInit = 3,
  ngAfterContentChecked = 4,
  ngAfterViewInit = 5,
  ngAfterViewChecked = 6,
  ngOnDestroy = 7,
}
